import { useState } from "react";
import {
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Portal,
} from "@mui/material";
import api from "../../services/api";
import FazerObservacoes from "../components/fazerObservacoes."; // <-- importado aqui
import ButtonLeft from "../../utils/buttonLeft";

const ChangeStatusEstabelecimento = ({
  estabelecimentoId,
  onStatusChange,
  currentStatus,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(false);
  const [obs, setObs] = useState(""); // <-- observação escrita
  const [showForm, setShowForm] = useState(false); // <-- controla se mostra o form

  const newStatus = currentStatus === "Activo" ? "Inactivo" : "Activo";

  const toggleStatus = async () => {
    setLoading(true);
    setError(null);

    try {
      await api.patch("/estabelecimento/change-status", {
        status: newStatus,
        estabelecimentoId,
        descricao: obs, // <-- inclui a observação na requisição
      });
      onStatusChange(newStatus);
      setSuccessMessage(true);
      setShowForm(false);
      setObs("");
    } catch (error) {
      // console.error("Erro ao alterar status", error);
      setError("Erro ao alterar status. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {!showForm ? (
        <Button
          variant="outlined"
          style={{ width: "100%" }}
          color={currentStatus === "Activo" ? "error" : "success"}
          onClick={() => setShowForm(true)} // <-- mostra o formulário
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : currentStatus === "Activo" ? (
            "Inactivar"
          ) : (
            "Activar"
          )}
        </Button>
      ) : (
        <>
          <FazerObservacoes
            observacao={null}
            setObs={setObs}
            obs={obs}
            titulo="(Descreve aqui os motivos da alteração de status)"
          />

          <ButtonLeft
            title={'Salvar'}
            funcao={toggleStatus}
            load={loading}
            disabled={loading || !obs}
          >
            <Button onClick={() => { setShowForm(false); setObs(""); }} color="error" size="small">Cancelar</Button>
          </ButtonLeft>
        </>
      )}

      <Portal>
        <Snackbar
          open={successMessage}
          autoHideDuration={3000}
          onClose={() => setSuccessMessage(false)}
        >
          <Alert severity="success">Status alterado com sucesso!</Alert>
        </Snackbar>
      </Portal>

      {error && <Alert severity="error">{error}</Alert>}
    </div>
  );
};

export default ChangeStatusEstabelecimento;
